<div *ngIf="appCopy" class="miles-container bg-white">
  <div class="logo-section flex-always flex--space-between" style="align-items: start; gap: 15px">

    <div>
      <h5 class="text-dark-blue ng-star-inserted" style="margin: 0">
        {{appCopy.panelHeader['milesTitle'+selectedLanguage]}}
      </h5>
      <h5 class="text-dark-blue ng-star-inserted" style="margin-top: 0">
        {{appCopy.panelHeader['balance'+selectedLanguage]}}: {{ milesBalance | number }}
      </h5>
    </div>
    <img
      class="miles-logo"
      src="./images/Miles-More-Logo.png"
      alt="Miles-More-Logo"
    />
  </div>
  <form [formGroup]="milesAndMoreForm" style="width: 100%">
    <div class="flex-always">
      <!-- <div [ngStyle]="{ width: preFilledWidth }">
        <div class="filledMiles"></div>
      </div> -->
      <mat-slider
      class="mm-slider"
      [disabled]="
        milesBalance < min
        || milesRedeemed
        || !canSpendMiles"
        [max]="max"
        [min]="min"
        [step]="step"
        showTickMarks
        [discrete]="thumbLabel"
        [displayWith]="formatLabel">
        <input matSliderThumb formControlName="sliderValue">
      </mat-slider>
    </div>

    <div class="flex-always" style="margin-top: -16px">
      <div>
        <p style="text-align: end">
          <small>{{ min | number }}</small>
        </p>
      </div>
      <div style="width: 100%">
        <p *ngIf="min < max" style="text-align: end">
          <small>{{ max | number }}</small>
        </p>
      </div>
    </div>

    <div class="text-dark-blue text-sm" *ngIf="!milesRedeemed && milesBalance > min && max < min">
      <p>{{appCopy.panelHeader['lowPriceMilesReward'+selectedLanguage]}}</p>
    </div>
    <div class="has-error text-sm" *ngIf="milesAndMoreForm?.get('sliderValue')?.invalid && min < max">
      <p>Value must be between {{ min | number }} and {{ max | number }}</p>
    </div>
    <!-- <div class="has-error error" *ngIf="bookingRemainingPrice?.price < 0">
      <p>{{appCopy.panelHeader['lowBookingPrice'+selectedLanguage]}}</p>
    </div> -->
    <!-- <input
      type="number"
      #milesInp
      (keyup.enter)="handleMilesChange(milesInp)"
      (blur)="handleMilesChange(milesInp)"
      [value]="value"
      formControlName="sliderValueInp"
    /> -->

    <div class="info-section">
      <ul style="padding-left: 17px;">
        <li>
          <p class="text-dark-blue" [innerHTML]="formattedNumString('spendMiles', value)">
            Miles & More Award miles: <b>{{ value | number }}</b>
          </p>
        </li>
        <li>
          <p class="text-dark-blue">
            {{appCopy.panelHeader['ramainingBalance'+selectedLanguage]}}
             <b>{{ bookingRemainingPrice?.viewPrice }}</b>
          </p>
        </li>
      </ul>
      <p class="text-dark-blue">
        <!-- {CHF/€/£}1 -->
        <b [innerHTML]="formattedString_date('beneficiaryText')">{{appCopy.panelHeader['beneficiaryText'+selectedLanguage]}}</b>
      </p>
    </div>
    <button
      id="formPayment-submit"
      style="height: 48px; width: 200px; margin-left: auto;"
      type="button"
      class="btn btn-primary tether-payment-target"
      [title]="milesBalance < min ? appCopy.panelHeader['lowOnMiles'+selectedLanguage] : bookingRemainingPrice?.price < 0 ? appCopy.panelHeader['lowBookingPrice'+selectedLanguage] : ''"
      [disabled]="
      milesBalance < min ||
      milesRedeemed ||
      bookingRemainingPrice?.price < 0 ||
      milesRedeemLoadingStatus === 'loading' ||
      !canSpendMiles"
      (click)="redeemMiles()"
    >
    {{appCopy.panelHeader['redeemBtn'+selectedLanguage]}}
      <div class="loader-container-btn" *ngIf="milesRedeemLoadingStatus === 'loading'">
        <div class="loader loader--white">
          <svg class="circular" viewBox="25 25 50 50">
            <circle class="path" cx="50" cy="50" r="20" />
          </svg>
        </div>
      </div>
    </button>
  </form>
  <div class="alert alert-warning text-sm"
  *ngIf="isPriceAdjusted">
    <p>{{appCopy.panelHeader['reloginText'+selectedLanguage]}} <button (click)="milesLoginRedirect()" type="button" class="btn btn-inline btn-ghost">{{appCopy.panelHeader['loginBtn'+selectedLanguage]}}</button></p>
  </div>
</div>
